
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire02cb"];
var parcelRegister = parcelRequire.register;
parcelRegister("8Mxwq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8691be4b3e3340fc$export$2e2bcd8739ae039; });

var $1dxTK = parcelRequire("1dxTK");

var $4PVqE = parcelRequire("4PVqE");

var $88yio = parcelRequire("88yio");

var $9CClu = parcelRequire("9CClu");

var $jIyMJ = parcelRequire("jIyMJ");

var $6a2bU = parcelRequire("6a2bU");

var $jG0RD = parcelRequire("jG0RD");

var $ijex0 = parcelRequire("ijex0");

var $jBi9x = parcelRequire("jBi9x");

var $jVFwa = parcelRequire("jVFwa");

var $aHJeV = parcelRequire("aHJeV");
const $8691be4b3e3340fc$var$FeedView = ({ readAllButton: readAllButton = false, t: t, onReadAll: onReadAll = ()=>{}, ...props })=>{
    const [readAllNotificationsMutation, { loading: readAllNotificationsMutationLoading }] = (0, $4PVqE.useMutation)((0, $9CClu.default)((0, (/*@__PURE__*/$parcel$interopDefault($aHJeV)))));
    const handleReadAll = async ()=>{
        await readAllNotificationsMutation();
        (0, $6a2bU.refreshCurrentUser)(true);
        onReadAll();
    };
    return /*#__PURE__*/ (0, $1dxTK.jsxs)((0, $1dxTK.Fragment), {
        children: [
            readAllButton && /*#__PURE__*/ (0, $1dxTK.jsx)((0, $jVFwa.default), {
                transparent: true,
                children: /*#__PURE__*/ (0, $1dxTK.jsx)((0, $jBi9x.default), {
                    position: "RIGHT",
                    children: /*#__PURE__*/ (0, $1dxTK.jsx)((0, $ijex0.default), {
                        loading: readAllNotificationsMutationLoading,
                        icon: (0, $88yio.faEyeSlash),
                        theme: "SECONDARY",
                        label: t("Mark as read"),
                        action: handleReadAll
                    })
                })
            }),
            /*#__PURE__*/ (0, $1dxTK.jsx)((0, $jG0RD.default), {
                ...props,
                actionFunction: (id)=>`/notifications/${id}/`
            })
        ]
    });
};
var $8691be4b3e3340fc$export$2e2bcd8739ae039 = (0, $jIyMJ.withTranslation)()($8691be4b3e3340fc$var$FeedView);

});
parcelRegister("jG0RD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e878218b72106bd$export$2e2bcd8739ae039; });

var $1dxTK = parcelRequire("1dxTK");

var $aX1RZ = parcelRequire("aX1RZ");

var $jIyMJ = parcelRequire("jIyMJ");

var $e3KKA = parcelRequire("e3KKA");

var $f37rc = parcelRequire("f37rc");

var $dFPgv = parcelRequire("dFPgv");

var $jVFwa = parcelRequire("jVFwa");

var $5iD7c = parcelRequire("5iD7c");

var $easZS = parcelRequire("easZS");

var $9yBxF = parcelRequire("9yBxF");
const $4e878218b72106bd$var$ActivityFeed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aX1RZ))).memo((0, $jIyMJ.withTranslation)()(({ activities: activities, t: t, displayType: displayType = "FEED", isScrollable: isScrollable = false, actionFunction: actionFunction = ()=>{} })=>/*#__PURE__*/ (0, $1dxTK.jsx)((0, $jVFwa.default), {
        className: `${isScrollable ? $9yBxF.isScrollable : ""}`,
        disablePadding: true,
        children: activities.map((activity)=>/*#__PURE__*/ (0, $1dxTK.jsxs)("div", {
                className: `${$9yBxF.activityLine} ${activity.node.isRead ? $9yBxF.isRead : ""}`,
                children: [
                    /*#__PURE__*/ (0, $1dxTK.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $1dxTK.jsx)((0, $easZS.default), {
                                className: $9yBxF.avatar,
                                ...activity.node.user,
                                animatedPicture: null
                            }),
                            /*#__PURE__*/ (0, $1dxTK.jsx)((0, $f37rc.default), {
                                action: actionFunction(activity.node.id),
                                className: $9yBxF.activityMessage,
                                children: /*#__PURE__*/ (0, $1dxTK.jsx)((0, $dFPgv.default), {
                                    value: (0, $e3KKA.getNotificationText)(t, activity.node.type, activity.node.arguments, displayType),
                                    options: {
                                        emojis: []
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1dxTK.jsx)((0, $f37rc.default), {
                        action: actionFunction(activity.node.id),
                        className: $9yBxF.date,
                        children: /*#__PURE__*/ (0, $1dxTK.jsx)((0, $5iD7c.default), {
                            timestamp: activity.node.createdAt,
                            relative: true
                        })
                    })
                ]
            }, activity.node.id))
    })));
var $4e878218b72106bd$export$2e2bcd8739ae039 = $4e878218b72106bd$var$ActivityFeed;

});
parcelRegister("e3KKA", function(module, exports) {

$parcel$export(module.exports, "getNotificationText", function () { return $a3c59c29c7ce221f$export$cac7cb63747f3a1a; });

var $cLPcx = parcelRequire("cLPcx");
const $a3c59c29c7ce221f$var$notifications = {
    FREE: {
        generic: (t, args)=>t("{{content}}", args)
    },
    // Community recomended brickfilms
    DISCOVER_BRICKFILM_MONTH: {
        generic: (t, args)=>t('Discover "[b]{{brickfilm_title}}[/b]" by {{brickfilm_author_login}}, last month\'s best brickfilm.', args)
    },
    DISCOVER_BRICKFILM_WEEK: {
        generic: (t, args)=>t('Discover "[b]{{brickfilm_title}}[/b]" by {{brickfilm_author_login}}, the most promising brickfilm of the week.', args)
    },
    DISCOVER_BRICKFILM_RECOMMENDED: {
        generic: (t, args)=>t('The community recommends "[b]{{brickfilm_title}}[/b]".', args)
    },
    // Articles
    ARTICLE_PUBLISHED: {
        generic: (t, args)=>t('The article "[b]{{article_title}}[/b]" has been published, go check it out!', args)
    },
    ARTICLE_EDITED: {
        generic: (t, args)=>t('The article "[b]{{article_title}}[/b]" has been edited.', args)
    },
    ARTICLE_PENDING: {
        generic: (t, args)=>t('The article "[b]{{article_title}}[/b]" is awaiting moderation.', args)
    },
    // Brickfilms
    BRICKFILM_PUBLISHED: {
        generic: (t, args)=>t('[b]{{brickfilm_author_login}}[/b] just published the brickfilm "[b]{{brickfilm_title}}[/b]".', args)
    },
    BRICKFILM_RELEASED: {
        generic: (t, args)=>t("[b]{{brickfilm_title}}[/b], the latest brickfilm by {{brickfilm_author_login}} has been published.", args)
    },
    BRICKFILM_EDITED: {
        generic: (t, args)=>t('[b]{{brickfilm_author_login}}[/b] has updated the brickfilm "[b]{{brickfilm_title}}[/b]".', args)
    },
    BRICKFILM_MAKINGOF_ADDED: {
        generic: (t, args)=>t('[b]{{brickfilm_author_login}}[/b] has added a making-of about the brickfilm project "[b]{{brickfilm_title}}[/b]".', args)
    },
    // Project brickfilm
    PROJECT_PUBLISHED: {
        generic: (t, args)=>t('[b]{{brickfilm_author_login}}[/b] just published the brickfilm project "[b]{{brickfilm_title}}[/b]".', args)
    },
    PROJECT_EDITED: {
        generic: (t, args)=>t('[b]{{brickfilm_author_login}}[/b] has updated the brickfilm project "[b]{{brickfilm_title}}[/b]".', args)
    },
    PROJECT_TEASER_RELEASED: {
        generic: (t, args)=>t('[b]{{brickfilm_author_login}}[/b] has added a teaser about the brickfilm project "[b]{{brickfilm_title}}[/b]".', args)
    },
    PROJECT_PRODUCTION_ADDED: {
        generic: (t, args)=>t('[b]{{brickfilm_author_login}}[/b] has added a production note about the brickfilm project "[b]{{brickfilm_title}}[/b]".', args)
    },
    // Resources
    RESOURCE_PUBLISHED: {
        generic: (t, args)=>t('[b]{{resource_author_login}}[/b] just published the resource "[b]{{resource_title}}[/b]".', args)
    },
    RESOURCE_EDITED: {
        generic: (t, args)=>t('[b]{{resource_author_login}}[/b] has updated the resource "[b]{{resource_title}}[/b]".', args)
    },
    // Badges
    BADGE_RECEIVED: {
        feed: (t, args)=>t('[b]{{user_login}}[/b] just obtained the badge "[b]{{badge_title}}[/b]".', {
                ...args,
                badge_title: (0, $cLPcx.getBadgeTitle)(args?.badge_id, t)
            }),
        notification: (t, args)=>t('You just obtained the badge "[b]{{badge_title}}[/b]", it will now show up on your profile page.', {
                ...args,
                badge_title: (0, $cLPcx.getBadgeTitle)(args?.badge_id, t)
            })
    },
    // Users
    USER_SUBSCRIBED: {
        feed: (t, args)=>t("[b]{{user_login}}[/b] has subscribed to [b]{{subscriber_login}}[/b], they will be informed of new publications.", args),
        notification: (t, args)=>t("[b]{{user_login}}[/b] has subscribed to you, they will be informed of your new publications.", args)
    },
    USER_REGISTERED: {
        generic: (t, args)=>t("[b]{{user_login}}[/b] just joined the community, welcome!", args)
    },
    USER_BUY_PREMIUM: {
        feed: (t, args)=>t("[b]{{user_login}}[/b] subscribed to the premium plan. Thanks for your support!", args),
        notification: (t, args)=>t("You are now [b]premium[/b], thank you for supporting the community!", args)
    },
    USER_BUY_DONATOR: {
        feed: (t, args)=>t("[b]{{user_login}}[/b] subscribed to the donator plan. Thanks for your support!", args),
        notification: (t, args)=>t("You are now [b]donator[/b], thank you for supporting the community!", args)
    },
    USER_RECEIVED_BOOSTS: {
        notification: (t, args)=>{
            if (parseInt(args.number_of_boosts, 10) > 1) return t("You have received [b]{{number_of_boosts}} brickfilm boosts[/b], boost your brickfilms to highlight them on the website.", args);
            if (parseInt(args.number_of_boosts, 10) === 1) return t("You have received [b]one brickfilm boost[/b], boost your brickfilms to highlight them on the website.", args);
            return t("You have received [b]{{number_of_boosts}} brickfilm boost[/b], boost your brickfilms to highlight them on the website.", args);
        }
    },
    // Contest
    CONTEST_REGISTERED: {
        generic: (t, args)=>t('[b]{{user_login}}[/b] has just entered the "[b]{{contest_title}}[/b]" contest with "[b]{{brickfilm_title}}[/b]".', args)
    },
    // Messages
    MESSAGE_ADDED: {
        feed: (t, args)=>args.message_first === "true" ? t('[b]{{message_author_login}}[/b] posted {{kind}} "[b]{{parent_title}}[/b]".', args) : t('[b]{{message_author_login}}[/b] replied {{kind}} "[b]{{parent_title}}[/b]".', args),
        notification: (t, args)=>t('New messages have been posted {{kind}} "[b]{{parent_title}}[/b]".', args)
    },
    MESSAGE_DELETED: {
        feed: (t, args)=>t('The message by [b]{{message_author_login}}[/b] {{kind}} "[b]{{parent_title}}[/b]" has been deleted.', args),
        notification: (t, args)=>t('Your message posted {{kind}} "[b]{{parent_title}}[/b]" has been deleted.', args)
    },
    MESSAGE_EDITED: {
        feed: (t, args)=>t('The message by [b]{{message_author_login}}[/b] {{kind}} "[b]{{parent_title}}[/b]" has been edited.', args),
        notification: (t, args)=>t('Your message posted {{kind}} "[b]{{parent_title}}[/b]" has been edited.', args)
    },
    MESSAGE_LIKED: {
        feed: (t, args)=>t('The message by [b]{{message_author_login}}[/b] {{kind}} "[b]{{parent_title}}[/b]" has been liked.', args),
        notification: (t, args)=>t('Your message posted {{kind}} "[b]{{parent_title}}[/b]" has been liked.', args)
    },
    MESSAGE_UNLIKED: {
        feed: (t, args)=>t('The message by [b]{{message_author_login}}[/b] {{kind}} "[b]{{parent_title}}[/b]" is no longer liked.', args),
        notification: (t, args)=>t('Your message posted {{kind}} "[b]{{parent_title}}[/b]" is no longer liked.', args)
    },
    MESSAGE_RESTORED: {
        feed: (t, args)=>t('The message by [b]{{message_author_login}}[/b] posted {{kind}} "[b]{{parent_title}}[/b]" has been restored.', args),
        notification: (t, args)=>t('Your message posted {{kind}} "[b]{{parent_title}}[/b]" has been restored.', args)
    },
    MESSAGE_DESTROYED: {
        feed: (t, args)=>t('The message by [b]{{message_author_login}}[/b] posted {{kind}} "[b]{{parent_title}}[/b]" has been destroyed.', args),
        notification: (t, args)=>t('Your message posted {{kind}} "[b]{{parent_title}}[/b]" has been destroyed.', args)
    },
    MESSAGE_QUOTED: {
        notification: (t, args)=>t('You have been mentioned {{kind}} "[b]{{parent_title}}[/b]".', args)
    },
    GENERATOR_DONE: {
        notification: (t, args)=>t("Your customized video is ready, you can download it from the opening generator.", args)
    }
};
const $a3c59c29c7ce221f$var$parentTypes = {
    BRICKFILM: (t)=>t("on the brickfilm"),
    ARTICLE: (t)=>t("on the article"),
    THREAD: (t)=>t("on the thread"),
    PROJECT: (t)=>t("on the project"),
    RESOURCE: (t)=>t("on the resource"),
    UNKNOWN: (t)=>t("on the document")
};
const $a3c59c29c7ce221f$export$cac7cb63747f3a1a = (t, type, args, mode)=>{
    const func = $a3c59c29c7ce221f$var$notifications[type];
    let convertedArgs = args.reduce((acc, e)=>({
            ...acc,
            [e.name]: e.value
        }), {});
    // Add sub translation for message kind
    if (type.startsWith("MESSAGE_")) convertedArgs.kind = $a3c59c29c7ce221f$var$parentTypes?.[convertedArgs.parent_type]?.(t) || $a3c59c29c7ce221f$var$parentTypes.UNKNOWN(t);
    // Anonymous user
    if (convertedArgs.message_author_login === null) convertedArgs.message_author_login = t("Anonymous");
    return func?.[mode.toLowerCase()]?.(t, convertedArgs) || func?.generic?.(t, convertedArgs) || null;
};

});

parcelRegister("9yBxF", function(module, exports) {

$parcel$export(module.exports, "activityLine", function () { return $6f546917d65e2cfe$export$e6f4dc752cde24fe; }, function (v) { return $6f546917d65e2cfe$export$e6f4dc752cde24fe = v; });
$parcel$export(module.exports, "activityMessage", function () { return $6f546917d65e2cfe$export$6fdcf1b024e31dd9; }, function (v) { return $6f546917d65e2cfe$export$6fdcf1b024e31dd9 = v; });
$parcel$export(module.exports, "avatar", function () { return $6f546917d65e2cfe$export$345c5736c8054f22; }, function (v) { return $6f546917d65e2cfe$export$345c5736c8054f22 = v; });
$parcel$export(module.exports, "date", function () { return $6f546917d65e2cfe$export$324d90190a8b822a; }, function (v) { return $6f546917d65e2cfe$export$324d90190a8b822a = v; });
$parcel$export(module.exports, "isRead", function () { return $6f546917d65e2cfe$export$72dc5d2f8146e55e; }, function (v) { return $6f546917d65e2cfe$export$72dc5d2f8146e55e = v; });
$parcel$export(module.exports, "isScrollable", function () { return $6f546917d65e2cfe$export$2bb74740c4e19def; }, function (v) { return $6f546917d65e2cfe$export$2bb74740c4e19def = v; });
var $6f546917d65e2cfe$export$e6f4dc752cde24fe;
var $6f546917d65e2cfe$export$6fdcf1b024e31dd9;
var $6f546917d65e2cfe$export$345c5736c8054f22;
var $6f546917d65e2cfe$export$324d90190a8b822a;
var $6f546917d65e2cfe$export$72dc5d2f8146e55e;
var $6f546917d65e2cfe$export$2bb74740c4e19def;
$6f546917d65e2cfe$export$e6f4dc752cde24fe = `WQZ66q_activityLine`;
$6f546917d65e2cfe$export$6fdcf1b024e31dd9 = `WQZ66q_activityMessage`;
$6f546917d65e2cfe$export$345c5736c8054f22 = `WQZ66q_avatar`;
$6f546917d65e2cfe$export$324d90190a8b822a = `WQZ66q_date`;
$6f546917d65e2cfe$export$72dc5d2f8146e55e = `WQZ66q_isRead`;
$6f546917d65e2cfe$export$2bb74740c4e19def = `WQZ66q_isScrollable`;

});


parcelRegister("aHJeV", function(module, exports) {
module.exports = "mutation ReadAllNotificationsMutation{readAllNotifications}";

});



//# sourceMappingURL=Homepage.083653e7.js.map
